import { Flex } from '@chakra-ui/react';
import { CircleCheckIcon } from '@/shared/ui';

const items = ['14-day free trial', 'No contracts', 'No credit card up front'];

const StrongSides = () => (
  <Flex
    mt='lg'
    gap={{ base: 'md', md: '2xl' }}
    alignSelf='center'
    flexDir={{ base: 'column', md: 'row' }}
  >
    {items.map((item) => (
      <Flex
        key={item}
        alignItems='center'
        fontSize='lg'
        gap='1'
      >
        <CircleCheckIcon
          boxSize={6}
          color='green'
        />
        {item}
      </Flex>
    ))}
  </Flex>
);

export default StrongSides;
